import { Accordion, Avatar, BodyText, Heading } from '@farol-ds/react'
import classNames from 'classnames'
import { useMemo } from 'react'

import {
  Comments_DocumentFragment,
  Comments_ViewerFragment,
} from '../__generated__/comments.graphql'
import { PublishComment } from '../components'
import { CommentList } from '../components/commentList'
import styles from './accordion-comments.module.scss'

export interface AccordionCommentsProps {
  document: Comments_DocumentFragment
  viewer: Comments_ViewerFragment | null
  onLoadMore?: () => void
  className?: string
}

export function AccordionComments(props: AccordionCommentsProps) {
  const { document, viewer, onLoadMore, className } = props

  const accordionTypeTotalCommentsLabel = useMemo(() => {
    return `Comentários (${document.numComments})`
  }, [document.numComments])

  const classes = classNames(styles.container, className)

  return (
    <>
      <Accordion type="single" collapsible={true} size={'xl'} className={className}>
        <Accordion.Item value="comments">
          <Accordion.Header data-testid="accordion-comments-header">
            <Accordion.Title>
              <div className={classes}>
                <div className={styles.containerTitle} id="comments">
                  <Heading size="lg" asChild>
                    <p>{accordionTypeTotalCommentsLabel}</p>
                  </Heading>

                  <BodyText size={'md'}>
                    Confira os comentários realizados por outras pessoas sobre esse artigo.
                  </BodyText>
                </div>
              </div>
            </Accordion.Title>
          </Accordion.Header>
          <Accordion.Content forceMount className={styles.accordionContent}>
            <div className={styles.container}>
              <div className={styles.avatar}>
                <Avatar
                  size="lg"
                  src={viewer?.thumborImage?.current || undefined}
                  alt={viewer?.name || 'unlogged'}
                  loading="lazy"
                />
                <BodyText size="md" asChild>
                  <span>
                    {viewer ? `${viewer.name}, f` : 'F'}aça comentário construtivo para esse
                    documento
                  </span>
                </BodyText>
              </div>
              <PublishComment document={document} viewer={viewer} />
              <CommentList document={document} viewer={viewer} onLoadMore={onLoadMore} />
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </>
  )
}
